module.exports = __webpack_public_path__ + "img/vertical_4_7_3009.dc1085f6.png";